import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Page = styled.div`
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, ${props => props.theme.palette.colors.shellGradientStart} 0%, ${props => props.theme.palette.colors.shellGradientEnd} 34%),
    ${props => props.theme.palette.colors.background};
  color: ${props => props.theme.palette.colors.text};
`

export const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid ${props => props.theme.palette.colors.borderSoft};
  background: ${props => props.theme.palette.colors.panelBackdrop};
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
`

export const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: min(100% - 40px, 1120px);
  min-height: 88px;
  margin: 0 auto;

  @media (max-width: 767px) {
    width: min(100% - 32px, 1120px);
    min-height: 74px;
  }
`

export const BrandLink = styled(Link)`
  display: inline-flex;
  align-items: center;

  img {
    width: clamp(190px, 30vw, 250px);
    margin: 0;
  }

  &:focus-visible {
    border-radius: 6px;
    outline: 2px solid ${props => props.theme.palette.blue.main};
    outline-offset: 5px;
  }
`

export const BrandLogo = styled.img.attrs(props => ({
  src: `/icons/${props.theme.mode === 'light' ? 'MV_Universe_Logo' : 'MV_Universe_Logo_white'}.svg`,
}))`
  width: clamp(190px, 30vw, 250px);
  margin: 0;
`

export const BackLink = styled(Link)`
  color: ${props => props.theme.palette.colors.muted};
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover,
  &:focus-visible {
    color: ${props => props.theme.palette.colors.text};
  }

  &:focus-visible {
    border-radius: 4px;
    outline: 2px solid ${props => props.theme.palette.blue.main};
    outline-offset: 5px;
  }

  @media (max-width: 620px) {
    font-size: 0;

    &::after {
      content: 'Back';
      font-size: 14px;
    }
  }
`

export const PageMain = styled.main`
  width: min(100% - 40px, 920px);
  margin: 0 auto;
  padding: 80px 0 96px;

  @media (max-width: 767px) {
    width: min(100% - 32px, 920px);
    padding: 52px 0 64px;
  }
`

export const PageHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 40px;
  border-bottom: 1px solid ${props => props.theme.palette.colors.borderSoft};

  p {
    margin: 24px 0 0;
    color: ${props => props.theme.palette.colors.subdued};
    font-family: Lato;
    font-size: 14px;
    line-height: 1.5;
  }
`

export const PageEyebrow = styled.span`
  margin-bottom: 14px;
  color: ${props => props.theme.palette.blue.main};
  font-family: Lato;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`

export const PageTitle = styled.h1`
  margin: 0;
  color: ${props => props.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: clamp(44px, 7vw, 72px);
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.035em;
`

export const PageIntro = styled.div`
  max-width: 680px;
  margin-top: 22px;
  color: ${props => props.theme.palette.colors.muted};
  font-family: Gilroy-Regular;
  font-size: clamp(18px, 2.5vw, 22px);
  line-height: 1.5;
`

export const PolicyArticle = styled.article`
  padding-top: 48px;

  @media (max-width: 767px) {
    padding-top: 36px;
  }
`
